import { FC } from "react";
//#region components
import WintSalaryReportTable from "./wintSalaryReportTable";
import { useReApproveContext } from "../context/useReApproveContext";
//#endregion

const ReApprovePreview: FC = () => {
  const { personData: data, loading } = useReApproveContext();

  return (
    <WintSalaryReportTable
      rows={data ? [data] : []}
      loading={loading}
      hiddenColumns={["state", "salaryYearMonth"]}
      hideMoreActionsButton
      hidePagination
      expandFirstRowByDefault
    />
  );
};

export default ReApprovePreview;
